import React from 'react'
import { Form, Typography } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import { useSearchMetadata } from '../useSearchMetadata'

const FilterRatings = () => {
  const { i18n } = useS4LContext()
  const { searchMetadata } = useSearchMetadata()

  const availableRatings = [9, 8, 7, 6] as const

  const ratingMessages = {
    9: i18n.formatMessage({ id: 'score.range-1' }),
    8: i18n.formatMessage({ id: 'score.range-2' }),
    7: i18n.formatMessage({ id: 'score.range-3' }),
    6: i18n.formatMessage({ id: 'score.range-4' }),
  } as const

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'global.guest-rating' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>
      {availableRatings.map(rating => {
        const count = searchMetadata?.guestRatings?.getByKey(rating.toString())?.count ?? 0

        return (
          <Form.Label key={`rating-${rating}`}>
            {ratingMessages[rating]}
            {`: ${rating}+`}
            {searchMetadata && (
              <Typography variant="caption" size="m" color="neutral-800">
                {count}
              </Typography>
            )}
            <Form.Checkbox
              disabled={searchMetadata && !count}
              name="ratings"
              multiple
              trueValue={rating}
            />
          </Form.Label>
        )
      })}
    </Form.Fieldset>
  )
}

FilterRatings.displayName = 'SearchFilters.FilterRatings'
export default withErrorBoundary(FilterRatings)
